<template>
  <div class="testQuestions">
    <div style="display: flex">
      <el-button
        type="primary"
        @click="choseQuestion"
        v-if="admin === 1 || limit === 2"
        v-auth="'teachingResearch_/homework/choseQuestion'"
        >从题库选择</el-button
      >
      <!-- <el-button type="primary" @click="deleteChapterMaterials" v-if="admin===1||limit===2">批量删除</el-button> -->
    </div>
    <el-table
      v-auth="'teachingResearch_/homework/questionPageList'"
      ref="multipleTable"
      :data="testQuestionsList.records"
      style="width: 100%; margin-top: 21px"
      row-key="id"
      border
      @selection-change="selectionChange"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column
        type="index"
        :index="indexMethod"
        label="排序"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="question.questionTypeName"
        label="类型"
        width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="title" show-overflow-tooltip label="题干">
        <template slot-scope="scope">
          <div class="message" @click="getInfoById(scope.row.question.id)">
            <div class="htmltittle" v-html="scope.row.question.title"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="question.answer"
        label="答案"
        align="center"
        width="60"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.big != 1">{{ scope.row.question.answer || "-" }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="admin === 1 || limit === 2"
        label="操作"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <i
            v-auth="'teachingResearch_/homework/deleteHomeWorkItemByHomework'"
            class="el-icon-delete operation-style"
            @click="deleteChapterMaterials(scope.row)"
          ></i>
          <!-- <span class="operation-style" @click="bingKnowledgePoints">知识点</span> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-auth="'teachingResearch_/homework/questionPageList'"
      background
      layout="prev, pager, next, jumper,  total, sizes"
      style="margin-top: 20px; text-align: left"
      :total="testQuestionsList.total"
      :page-size="testQuestionsSearch.pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :current-page="testQuestionsSearch.pageNumber"
      @size-change="testQuestionsSizeChange"
      @current-change="testQuestionsCurrentChange"
    ></el-pagination>

    <!-- <el-pagination
      @size-change="testQuestionsSizeChange"
      @current-change="testQuestionsCurrentChange"
      :current-page="testQuestionsSearch.pageNumber"
      :page-sizes="[100, 200, 300, 400]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="400">
    </el-pagination> -->
    <el-dialog
      title="从题库选择"
      :visible.sync="questionDialogVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <question
        v-if="questionDialogVisible"
        :courseId="chapterForm.courseId"
        @sentMsg="sentMsg"
      ></question>
    </el-dialog>

    <el-dialog
      title="绑定知识点"
      :visible.sync="knowledgePointsDialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <knowledgePoints
        v-if="knowledgePointsDialogVisible"
        :chapterForm="chapterData"
        @knowledgePointsClose="knowledgePointsClose"
        @knowledgePointsSubmit="knowledgePointsSubmit"
      ></knowledgePoints>
    </el-dialog>

    <el-dialog title="查看明细" :visible.sync="viewDetial" width="50%" left>
      <div class="view-content" v-if="viewForm.big == 1">
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">具体课程：</span>
            <span>{{ viewForm.courseName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">试题类型：</span>
            <span>{{
              viewForm.big == 1
                ? "大题"
                : viewForm.big == -1 && viewForm.pid.length == 1
                ? "小题"
                : "试题"
            }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">是否上架：</span>
            <span>{{ viewForm.state == 1 ? "上架" : "下架" }}</span>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题题干：</span>
          <span v-html="viewForm.title"></span>
        </div>
      </div>

      <div class="view-content" v-else>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">具体课程：</span>
            <span>{{ viewForm.courseName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">试题类型：</span>
            <span>{{
              viewForm.big == 1
                ? "大题"
                : viewForm.big == -1 && viewForm.pid.length == 1
                ? "小题"
                : "试题"
            }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">试题题型：</span>
            <span>{{ viewForm.questionTypeName }}</span>
          </div>
          <div>
            <span style="width: 70px; white-space: nowrap">是否上架：</span>
            <span>{{ viewForm.state == 1 ? "上架" : "下架" }}</span>
          </div>
        </div>
        <div class="view-two">
          <div>
            <span style="width: 70px; white-space: nowrap">难度系数：</span>
            <el-rate disabled v-model="viewForm.hard"></el-rate>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题题干：</span>
          <span v-html="viewForm.title"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题选项：</span>
          <div class="optint-list">
            <div v-for="(item, index) in viewForm.optionList" :key="index">
              <div style="font-size: 14px; height: 50px; line-height: 50px">
                {{ item.options }}:&nbsp;&nbsp;{{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题答案：</span>
          <span v-html="viewForm.answer"></span>
        </div>
        <div class="view-one">
          <span style="width: 70px; white-space: nowrap">试题解析：</span>
          <span v-html="viewForm.analysis"></span>
        </div>
        <div class="view-video">
          <span style="width: 70px; white-space: nowrap">视频/音频：</span>
          <span v-if="viewForm.videoPath">
            <video
              style="max-height: 400px; width: auto; margin-top: 20px"
              controls
              preload="auto"
              oncontextmenu="return false"
              :src="viewForm.videoPath"
              v-if="viewForm.videoPath ? viewForm.videoPath.indexOf('mp4') > -1 : false"
            ></video>
            <audio
              style="margin-top: 20px"
              :src="viewForm.videoPath"
              controls="controls"
              v-if="viewForm.videoPath ? viewForm.videoPath.indexOf('mp3') > -1 : false"
            ></audio>
          </span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="viewDetial = false">取 消</el-button>
        <el-button type="primary" @click="viewDetial = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import question from "../../common/question";
import knowledgePoints from "./knowledgePoints";
export default {
  components: { question, knowledgePoints },
  props: {
    chapterForm: {
      id: null,
    },
  },
  data() {
    return {
      // admin: JSON.parse(localStorage.getItem("user")).admin,
      // limit: JSON.parse(localStorage.getItem("jump")).limit,
      admin: 1,
      limit: 1,
      testQuestionsList: {
        records: [],
        total: 0,
        pageNumber: 1,
        pageSize: 10,
      },
      chapterData: {},
      classRoomTypeList: [],
      chapterId: "",
      testQuestionsSearch: {
        pageNumber: 1,
        pageSize: 10,
        chapterId: null,
      },
      classRoomSearch: {
        pageNumber: 1,
        pageSize: 10,
      },
      classRoomList: {},
      knowledgePointsDialogVisible: false,
      questionDialogVisible: false,
      KnowledgeTree: [],
      classRoomTypeList: [],
      viewForm: [], //查看
      viewDetial: false,
      ids: [],
      questionIds: [],
      jump: {},
    };
  },
  computed: {},
  methods: {
    /*--------------------------------------绑定试题------------------------------------ */
    sentMsg(ids) {
      let obj = {
        chapterId: this.chapterForm.id,
        questionList: [],
      };
      if (this.testQuestionsList.records.length > 0) {
        this.testQuestionsList.records.forEach((e) => {
          obj.questionList.push(e.question);
        });
        obj.id = this.testQuestionsList.records[0].homeworkId;
        ids.forEach((e) => {
          let d = true;
          this.testQuestionsList.records.forEach((item) => {
            if (e.id == item.question.id) {
              d = false;
            }
          });
          console.log("d", d);
          if (d) {
            obj.questionList.push({ id: e.id });
          }
        });
        this.api.homework.updateHomeworkQuestionForChapterId(obj).then((result) => {
          if (result.success) {
            this.questionPageList();
          } else {
            this.$message.error(result.message);
          }
        });
      } else {
        obj.questionList = ids;
        this.api.homework.addHomeworkByChapterId(obj).then((result) => {
          if (result.success) {
            this.questionPageList();
          } else {
            this.$message.error(result.message);
          }
        });
      }
      this.questionDialogVisible = false;
    },

    /*--------------------------------------绑定知识点------------------------------------ */
    bingKnowledgePoints() {
      this.chapterData = this.chapterForm;
      this.knowledgePointsDialogVisible = true;
    },

    knowledgePointsClose() {
      this.knowledgePointsDialogVisible = false;
    },

    knowledgePointsSubmit(knowledgePointsForm) {
      if (knowledgePointsForm.id == null) {
        this.$message.error("请选择知识点！");
      } else {
        this.knowledgePointsDialogVisible = false;
      }
    },

    /*--------------------------------------question列表------------------------------------ */
    indexMethod(index) {
      return index + 1 + (this.testQuestionsSearch.pageNumber - 1) * 10;
    },

    questionPageList() {
      this.testQuestionsList.records = [];
      this.testQuestionsSearch.chapterId = this.chapterForm.id;
      this.api.homework
        .questionPageList(this.testQuestionsSearch)
        .then((result) => {
          if (result.success) {
            this.testQuestionsList.records = result.data.records;
            this.testQuestionsList.total = result.data.total;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    testQuestionsSizeChange(pageSize) {
      this.testQuestionsSearch.pageSize = pageSize;
      this.questionPageList();
    },

    testQuestionsCurrentChange(pageNumber) {
      this.testQuestionsSearch.pageNumber = pageNumber;
      this.questionPageList();
    },

    //删除
    deleteChapterMaterials(row) {
      let obj = {
        id: row.homeworkId,
        questionList: [{ id: row.question.id }],
      };
      this.api.homework.deleteHomeWorkItemByHomework(obj).then((result) => {
        if (result.success) {
          this.questionPageList();
        } else {
          this.$message.error(result.message);
        }
      });
    },

    selectionChange(val) {
      let arr = [];
      val.map((e) => arr.push({ id: e.id }));
      this.ids = arr;
    },

    // 获取试题信息
    getInfoById(id) {
      this.api.question.getInfoById({ id: id }).then((result) => {
        if (result.success) {
          this.viewForm = result.data;
          this.viewDetial = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },

    choseQuestion() {
      this.questionDialogVisible = true;
    },
  },

  watch: {
    "chapterForm.id"(val, oldVal) {
      if (val) {
        console.log("val", val);
        this.questionPageList();
      }
    },
  },
  mounted() {
    // this.jump = JSON.parse(localStorage.getItem("jump"));
    this.questionPageList();
  },
};
</script>
<style scoped>
.testQuestions {
  background-color: #fff;
}
.testQuestions-button {
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background-color: rgba(77, 148, 255, 1);
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
}
.classRoomButton {
  height: 32px;
  width: 50px;
  background-color: rgba(77, 148, 255, 1);
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    span {
      display: block;
      font-size: 14px;
      line-height: 50px;
    }
  }
  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    .optint-list {
      display: flex;
      flex-direction: column;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 50px;
    }
  }
  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;
    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        display: block;
        font-size: 14px;
        line-height: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teachingResearch/components/homeworkQuestionList.vue